import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, saveAuth, errMsg } from "../lib/api";
import { GraduationCap, Eye, EyeSlash, ArrowLeft, ArrowRight } from "@phosphor-icons/react";

export default function Register() {
  const nav = useNavigate();
  const [f, setF] = useState({
    parent_email: "", parent_password: "", parent_name: "",
    student_username: "", student_password: "",
    child_name: "", grade: "7. sınıf",
    secondary_parent_email: "",
  });
  const [showP, setShowP] = useState(false);
  const [showS, setShowS] = useState(false);
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...f };
      if (!payload.secondary_parent_email) delete payload.secondary_parent_email;
      const { data } = await api.post("/auth/register", payload);
      saveAuth(data.token, data.profile, data.role);
      toast.success("Hesabın hazır! Çocuğun " + f.student_username + " ile giriş yapabilir.");
      nav("/parent");
    } catch (err) {
      toast.error(errMsg(err));
    } finally { setLoading(false); }
  };

  return (
    <div className="app-shell w-full max-w-md mx-auto min-h-[100dvh] px-6 py-10 flex flex-col">
      <div className="flex items-center justify-between mb-4">
        <Link to="/" data-testid="register-back-home" className="inline-flex items-center gap-2 text-brand-ink2 font-nunito font-semibold text-sm">
          <ArrowLeft size={18} /> Ana sayfa
        </Link>
        <Link
          to="/login"
          data-testid="register-top-login"
          className="inline-flex items-center gap-1 bg-brand-ink text-white px-4 py-2 rounded-full font-nunito font-bold text-sm shadow-sm active:scale-[0.98]"
        >
          Giriş yap <ArrowRight size={14} weight="bold" />
        </Link>
      </div>
      <div className="bg-brand-primary/15 border border-brand-primary/40 rounded-2xl px-4 py-3 mb-5 flex items-center gap-2 text-sm font-nunito">
        <span className="text-brand-ink">Zaten hesabın var mı?</span>
        <Link to="/login" className="ml-auto font-bold text-brand-ink underline underline-offset-4" data-testid="register-top-login-chip">Giriş yap →</Link>
      </div>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-2xl bg-brand-primary flex items-center justify-center">
          <GraduationCap size={28} weight="duotone" color="#1D3557" />
        </div>
        <div>
          <div className="font-outfit font-extrabold text-2xl text-brand-ink leading-none">Ödevix</div>
          <div className="font-nunito text-sm text-brand-ink2 mt-1">Hesabı siz açarsınız, çocuğunuz ayrı şifreyle girer.</div>
        </div>
      </div>

      <h1 className="font-outfit font-extrabold text-3xl tracking-tight text-brand-ink mb-2">Aile hesabı oluştur</h1>
      <p className="font-nunito text-brand-ink2 mb-6">Veli hesabınız ödev raporlarını, çocuğunuzun hesabı ödev yüklemeyi kullanır.</p>

      <form onSubmit={submit} className="flex flex-col gap-5">
        {/* Parent */}
        <div className="bg-white rounded-3xl p-4 shadow-sm">
          <div className="font-outfit font-bold text-sm text-brand-ink mb-2">👨‍👩 Veli (siz)</div>
          <input data-testid="reg-parent-email" type="email" required placeholder="E-posta" value={f.parent_email} onChange={set("parent_email")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink mb-2" />
          <input data-testid="reg-parent-name" placeholder="Adınız (opsiyonel)" value={f.parent_name} onChange={set("parent_name")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink mb-2" />
          <div className="relative">
            <input data-testid="reg-parent-password" type={showP ? "text" : "password"} required minLength={6} placeholder="Veli şifresi (6+ karakter)" value={f.parent_password} onChange={set("parent_password")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 pr-11 font-nunito text-brand-ink" />
            <button type="button" onClick={() => setShowP(!showP)} className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 text-brand-ink2">{showP ? <EyeSlash size={18} /> : <Eye size={18} />}</button>
          </div>
        </div>

        {/* Student */}
        <div className="bg-white rounded-3xl p-4 shadow-sm">
          <div className="font-outfit font-bold text-sm text-brand-ink mb-2">🎒 Öğrenci (çocuğunuz)</div>
          <input data-testid="reg-child-name" required placeholder="Çocuğunuzun adı" value={f.child_name} onChange={set("child_name")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink mb-2" />
          <select data-testid="reg-grade" value={f.grade} onChange={set("grade")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink mb-2">
            {["5. sınıf","6. sınıf","7. sınıf","8. sınıf","9. sınıf","10. sınıf"].map((g) => <option key={g} value={g}>{g}</option>)}
          </select>
          <input data-testid="reg-student-username" required minLength={3} placeholder="Öğrenci kullanıcı adı (örn: ela_2013)" value={f.student_username} onChange={set("student_username")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink mb-2" />
          <div className="relative">
            <input data-testid="reg-student-password" type={showS ? "text" : "password"} required minLength={6} placeholder="Öğrenci şifresi (6+ karakter)" value={f.student_password} onChange={set("student_password")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 pr-11 font-nunito text-brand-ink" />
            <button type="button" onClick={() => setShowS(!showS)} className="absolute right-3 top-1/2 -translate-y-1/2 p-1.5 text-brand-ink2">{showS ? <EyeSlash size={18} /> : <Eye size={18} />}</button>
          </div>
        </div>

        {/* Secondary parent optional */}
        <div className="bg-white rounded-3xl p-4 shadow-sm">
          <div className="font-outfit font-bold text-sm text-brand-ink mb-1">İkinci veli (opsiyonel)</div>
          <div className="text-xs font-nunito text-brand-ink2 mb-2">Baba/anne e-postası — sonradan panelden şifresi oluşturulur.</div>
          <input data-testid="reg-secondary-email" type="email" placeholder="ikinci-veli@mail.com" value={f.secondary_parent_email} onChange={set("secondary_parent_email")} className="w-full bg-brand-paper border border-black/10 rounded-2xl px-4 py-3 font-nunito text-brand-ink" />
        </div>

        <button
          data-testid="register-submit-button" type="submit" disabled={loading}
          className="mt-2 w-full bg-brand-primary text-brand-ink font-outfit font-bold text-lg py-4 rounded-full shadow-[0_4px_18px_rgba(255,183,3,0.45)] disabled:opacity-50"
        >{loading ? "Bekleniyor..." : "Aile hesabı oluştur"}</button>
      </form>

      <Link to="/login" data-testid="register-go-login" className="mt-6 font-nunito text-brand-ink2 text-sm text-center">
        Hesabın var mı? <span className="font-bold text-brand-ink underline underline-offset-4">Giriş yap</span>
      </Link>
    </div>
  );
}
